/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Reportingapikeys_Generate_Userplaceholder3Inputs */

const en_settings_reportingapikeys_generate_userplaceholder3 = /** @type {(inputs: Settings_Reportingapikeys_Generate_Userplaceholder3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search users by name or email`)
};

/**
* | output |
* | --- |
* | "Search users by name or email" |
*
* @param {Settings_Reportingapikeys_Generate_Userplaceholder3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_reportingapikeys_generate_userplaceholder3 = /** @type {((inputs?: Settings_Reportingapikeys_Generate_Userplaceholder3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Reportingapikeys_Generate_Userplaceholder3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_reportingapikeys_generate_userplaceholder3(inputs)
});
export { settings_reportingapikeys_generate_userplaceholder3 as "settings_reportingApiKeys_generate_userPlaceholder" }